export default __webpack_public_path__ + "1d55898a81bcbbc69c1d906afd643851.svg";